var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigninWithGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.575 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Google_ G _Logo"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M19.575 10.225a11.586 11.586 0 00-.158-1.892H10v3.761h5.392a4.642 4.642 0 01-2 2.983v2.5h3.217a9.777 9.777 0 002.966-7.352z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M10 20a9.526 9.526 0 006.608-2.421l-3.217-2.5a6.033 6.033 0 01-3.392.967 5.972 5.972 0 01-5.608-4.133H1.074v2.566A9.985 9.985 0 0010 20z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M4.392 11.909a5.8 5.8 0 01-.317-1.908 6.029 6.029 0 01.317-1.908V5.517H1.075A9.884 9.884 0 000 10a9.884 9.884 0 001.075 4.483z",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M10 3.961a5.426 5.426 0 013.833 1.5l2.85-2.85A9.561 9.561 0 0010 .003 9.985 9.985 0 001.075 5.52l3.317 2.575A5.972 5.972 0 0110 3.961z",
    fill: "#ea4335"
  }))));
}
export default SvgSigninWithGoogle;